<template>
  <div class="change-mobile-dialog">
    <el-dialog
      v-loading="loading"
      title="修改手机号"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div class="form-item">
        <label>手机号：</label>
        <el-input v-model="phone" placeholder="请输入手机号" />
      </div>
      <div class="form-item">
        <label>验证码：</label>
        <el-input v-model="code" placeholder="请输入验证码">
          <template #suffix>
            <el-button type="text" :disabled="disabled" @click="sendCode">{{ codeText }}</el-button>
          </template>
        </el-input>
      </div>
      <div class="options">
        <el-button type="primary" @click="submit">立即更改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeUnmount } from 'vue'
import { Message } from 'element-ui'
import API from '@/api'

const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  },
  oldMibile: {
    type: String,
    default: () => ''
  }
})
const emit = defineEmits(['handleCLose', 'toUpdate'])
const dialogVisible = computed(() => {
  return props.visible
})

//  关闭
function handleClose() {
  emit('update:visible', false)
}

/* 发送验证码 */
const phone = ref('')
const code = ref('')

const codeText = ref('发送验证码')
const time = ref(60)
const timer = ref(null)
const disabled = ref(false)
const sid = ref('')
async function sendCode() {
  if (!phone.value) {
    return Message.error('请先输入手机号码！')
  }
  const SidResp = await API.createCodeSid()
  sid.value = SidResp.data.sid
  if (sid.value && sid.value !== null) {
    loading.value = true
    API.sendCode({ phone: phone.value, sid: sid.value })
      .then(res => {
        if (+res.code === 200) {
          Message.success('验证码已发送，请注意查收！')
          codeTextChange()
        }
        loading.value = false
      })
      .catch(() => {
        loading.value = false
      })
  }
}

function codeTextChange() {
  clearInterval(timer.value)
  disabled.value = true
  timer.value = setInterval(() => {
    codeText.value = --time.value + 's'
    if (time.value === 0) {
      clearInterval(timer.value)
      codeText.value = '发送验证码'
      disabled.value = false
    }
  }, 1000)
}

function submit() {
  if (!phone.value) {
    return Message.error('手机号码未填写！')
  }
  if (!code.value) {
    return Message.error('手机验证码未填写！')
  }
  loading.value = true
  API.upDatePhone({ phone: phone.value, verifyCode: code.value, sid: sid.value })
    .then(res => {
      if (+res.code === 200) {
        Message.success('更新成功')
        emit('toUpdate')
      }
      loading.value = false
    })
    .catch(_ => {
      // Message.error('更新失败,请稍后再试')
      loading.value = false
    })
}

const loading = ref(false)

onBeforeUnmount(() => {
  clearInterval(timer.value)
})
</script>

<style lang="scss" scoped>
.form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  label {
    display: inline-block;
    width: 100px;
  }
}
.options {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
</style>
